import React from "react";

const LegendaUsers = () => {
  const legendItems = [
    {
      icon: "/img/markers/masc_blue.png",
      alt: "Masculino",
      text: "Usuário masculino",
    },
    {
      icon: "/img/markers/fem_pink.png",
      alt: "Feminino",
      text: "Usuário feminino",
    },
    {
      icon: "/img/markers/others.png",
      alt: "Outros",
      text: "Outros",
    },
    {
      icon: "http://maps.google.com/mapfiles/ms/icons/purple-dot.png",
      alt: "Interesse",
      text: "Imóvel de interesse",
    },
  ];

  return (
    <div>
      <div style={{ paddingBottom: '15px', fontStyle: 'italic', color: '#666', textAlign: 'center' }}>
        Ao selecionar um empreendimento no mapa, será calculada a distância dos usuários até ele.
      </div>
      <table className="table table-striped table-condensed legenda-mapa">
        <thead>
          <tr>
            <th colSpan="2" style={{ paddingBottom: 7 }}>
              <span
                className="font-weight-bold text-center"
                style={{ color: 'rgb(0, 72, 14)', fontSize: 16 }}
              >
                LEGENDA USUÁRIOS
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {legendItems.map((item, index) => (
            <tr key={index}>
              <td>
                <img src={item.icon} alt={item.alt} />
              </td>
              <td>{item.text}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LegendaUsers;